import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { AuthContainer, UtilsContainer } from 'containers'
import { Alert } from 'components'
import { ALL_PAGES } from 'constants/pages'
import { getPageCondition } from 'utils/utilities'

export const RedirectHandler = () => {
  const history = useHistory()
  const { pathname } = useLocation()

  const { isAuthenticated, acceptedTnC, accessLevels, userType, selectedSupplier } = AuthContainer.useContainer()
  const { redirectURL, setRedirectURL } = UtilsContainer.useContainer()
  const [open, setOpen] = React.useState(false)

  const pageLink = React.useMemo(() => ALL_PAGES.find((page) => pathname.includes(page.routeTo)), [pathname])
  const pageCondition = React.useMemo(
    () =>
      getPageCondition({
        condition: pageLink?.condition,
        userType,
        selectedSupplier,
      }),
    [pageLink, userType, selectedSupplier]
  )

  const isRedirectValid = () => {
    if (redirectURL.startsWith('/home')) return true
    if (redirectURL.startsWith('/admin')) return true
    if (redirectURL.startsWith('/supplier')) return true
    if (redirectURL.startsWith('/supplier-admin')) return true
    if (redirectURL.startsWith('/consolidator-haulier-admin')) return true
    if (redirectURL.startsWith('/sitemap')) return true

    return false
  }

  // Redirect if possible
  React.useEffect(() => {
    if (isAuthenticated && redirectURL) {
      if (isRedirectValid()) history.replace(redirectURL)
      setRedirectURL('')
    }

    // eslint-disable-next-line
  }, [isAuthenticated, redirectURL])

  // Open page disabled if applicable
  React.useEffect(() => {
    if (
      isAuthenticated &&
      acceptedTnC &&
      (!pageLink?.accessLevel || accessLevels.includes(pageLink.accessLevel)) &&
      !pageCondition.enabled
    ) {
      setOpen(true)
    } else {
      setOpen(false)
    }
  }, [isAuthenticated, acceptedTnC, accessLevels, pageLink, pageCondition])

  return (
    <>
      {open && (
        <Alert
          title={pageLink?.text ?? 'Please note'}
          message={pageCondition?.message ?? 'This page is disabled!'}
          open={open}
          onClose={() => {
            setOpen(false)
            history.replace('/home')
          }}
        />
      )}
    </>
  )
}
